import { observable } from 'mobx';
import moment, { type Moment } from 'moment';

export type SupportFeeElementResponseArgs = {
  id: number;
  content: string;
  reserved_at?: string;
};

export type SupportFeeElementArgs = {
  id: number;
  content: string;
  reservedAt?: Moment;
};

export const convertSupportFeeElementResponseToArgs = (response: SupportFeeElementResponseArgs) => {
  const args: SupportFeeElementArgs = {
    id: response.id,
    content: response.content,
    reservedAt: response.reserved_at ? moment(response.reserved_at) : undefined
  };
  return args;
};

export default class SupportFeeElement {
  @observable id: number;
  @observable content: string;
  @observable reservedAt?: Moment;

  constructor(args: SupportFeeElementArgs) {
    this.id = args.id;
    this.content = args.content;
    this.reservedAt = args.reservedAt;
  }

  get type() {
    return 'support_fee';
  }

  get startDate() {
    return null;
  }

  get endDate() {
    return null;
  }

  get title() {
    return '出張サポート費';
  }

  get summary() {
    return `[出張サポート費]${this.content}`;
  }

  get name() {
    return this.title;
  }

  // TODO: js/src/domain/order_item2.tsでフォールバックしてるから不要
  get mappingDescription(): string {
    return this.title;
  }

  detail() {
    return '';
  }

  validationErrors(_orderItemStatus?: number): string[] {
    const errors: string[] = [];

    if (!this.content || this.content === '') {
      errors.push('出張サポート費の内容を入力してください。');
    }

    return errors;
  }

  get description(): string {
    return `\
<出張サポート費>
■内容
${this.content}
■予約日
${this.reservedAt?.format('MM/DD')}\
`;
  }

  get updateParams() {
    return {
      type: this.type,
      content: this.content,
      reserved_at: this.reservedAt ? this.reservedAt.format('YYYY-MM-DD') : undefined
    };
  }

  get startTime() {
    return this.reservedAt;
  }

  get endTime() {
    return this.reservedAt;
  }
}
